<template>
  <hm-content title="">
    <div class="product-analysis">
      <div class="title">当前导购信息</div>
      <div class="flex mt20 flex-between">
        <div>导购姓名：{{ row.realname }}</div>
        <div>导购账号：{{ row.workNum }}</div>
        <div>导购手机号：{{ row.phone }}</div>
        <div>所属机构：{{ row.departName }}</div>
      </div>
    </div>
    <div class="product-analysis">
      <div class="flex flex-between item-center ">
        <div class="title">当前导购复购跟进汇总</div>
        <div style="margin-bottom: 18px;">
          <el-date-picker
            clearable
            :default-time="['00:00:00', '23:59:59']"
            v-model="createTimeArry"
            type="datetimerange"
            align="right"
            start-placeholder="请选择开始时间"
            end-placeholder="请选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
            @change="createTimeArryChange"
          ></el-date-picker>
        </div>
      </div>
      <div class="funnel flex flex-column flex-center">
        <div
          class="flex-1 funnel-row flex flex-between"
          v-for="(v, i) in h"
          :key="i"
        >
          <div class="flex">
            <div
              class="flex flex-column flex-center data-info"
              :class="v.datalist.length - 1 > index ? 'bor-right' : ''"
              v-for="(j, index) in v.datalist"
              :key="index"
            >
              {{ j.title }}
              <div class="text-left">
                <span v-if="i === 4 && index === 1" class="primary">
                  {{ ToFixed(j.val, 2) }}
                </span>
                <span v-else> {{ j.val }}</span>
              </div>
            </div>
          </div>

          <div
            class="flex flex-column flex-center tit"
            :class="i === 3 ? 'carts' : ''"
          >
            {{ v.name }}
          </div>
        </div>

        <div class="cover-purchase1">
          转化率
          <div>{{ ToFixed(purchase1, 2) }}%</div>
        </div>
        <div class="cover-purchase2">
          转化率
          <div>{{ ToFixed(purchase2, 2) }}%</div>
        </div>
        <div class="cover-purchase3">
          转化率
          <div>{{ ToFixed(purchase3, 2) }}%</div>
        </div>
        <div class="cover-purchase4">
          转化率
          <div>{{ ToFixed(purchase4, 2) }}%</div>
        </div>
        <div class="cover-purchase5">
          转化率
          <div>{{ ToFixed(purchase5, 2) }}%</div>
        </div>
      </div>
    </div>
    <div class="product-analysis">
      <div class="title">当前导购复购客户详细</div>

      <div class="table">
        <el-table
          border
          ref="table"
          :data="list"
          style="width: 100%"
          id="table"
          :header-cell-style="{ background: '#F7F7F7', color: '#606266' }"
          size="small"
          class="remind-plan"
          max-height="500"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column
            header-align="center"
            align="left"
            prop="rewardMode"
            label="客户信息"
            class-name="xxxx"
          >
            <template slot-scope="scope">
              <div class="border-b1 bg p10">
                <span class="mr20">
                  {{ scope.row.memberName }} 客户电话：{{
                    scope.row.memberMobile
                  }}
                </span>

                <span
                  v-for="(v, i) in scope.row.familyInfoVoList"
                  :key="i"
                  class="mr10"
                >
                  宝宝{{ i + 1 }}:
                  <span v-if="v.isPredicted === 'no'">
                    <span v-if="v.familyRelation === 'son'">男</span>
                    <span v-else-if="v.familyRelation === 'daughter'">女</span>
                  </span>
                  <span v-else>预产期</span>,{{ v.familyBirthdayStr }}({{
                    v.familyBirthday
                  }})
                </span>
              </div>
              <div
                class="border-b1 p20 flex item-center flex-between"
                v-for="(v, i) in scope.row.skuModelList"
                :key="i"
              >
                <div class="flex-1 flex">
                  <div class="mr10 flex item-center">
                    <el-image
                      style="width: 50px; height: 50px"
                      :src="v.spuMainPic"
                      :preview-src-list="[v.spuMainPic]"
                      class=" flex flex-center item-center"
                    >
                      <div
                        slot="error"
                        class="image-slot"
                        style="color:#c0c4cc"
                      >
                        暂无图片
                      </div>
                    </el-image>
                  </div>
                  <div style="white-space: nowrap">
                    <div>
                      {{ v.goodsName }}
                    </div>
                    <div>
                      <span class="orange mr20"
                        >{{ v.saleTime }}购买({{
                          moment().diff(v.saleTime, "days")
                        }}天前)
                      </span>
                      <span class="mr20">商品单价：¥{{ v.marketPrice }}</span>
                      <span class="mr20">商品数量：{{ v.goodsNumber }}</span>
                      <span class="mr20" v-if="v.saleAmount"
                        >实际付款：¥{{ v.saleAmount }}</span
                      >
                      <span class="mr20" v-else
                        ><el-tag size="small">赠品</el-tag></span
                      >
                    </div>
                  </div>
                </div>
                <div style="width:300px" class="flex flex-between">
                  <div class="orange mr20">
                    复购周期 {{ v.repurchaseCycleNum }} 天
                  </div>
                  <div>消费门店：{{ v.shopName }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="recommendRepurchaseTime"
            label="预计复购日期"
            width="100"
          >
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            width="100"
            label="导购"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.isHaveEmployee === 'yes'">
                {{ scope.row.realname }}
              </div>
              <el-button
                size="small"
                type="text"
                class="blue"
                v-else
                @click="getEmployee(scope.row)"
                >指定导购</el-button
              >
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="followUpState"
            width="100"
            label="是否跟进"
          >
            <template slot-scope="scope">
              <div
                :class="scope.row.followUpState === 'yes' ? 'success' : 'gray'"
              >
                {{ scope.row.followUpState === "yes" ? "已跟进" : "未跟进" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="visitStatus"
            width="100"
            label="是否访问"
          >
            <template slot-scope="scope">
              <div
                :class="
                  scope.row.followvisitStatusUpState === 'yes'
                    ? 'success'
                    : 'gray'
                "
              >
                {{ scope.row.visitStatus === "yes" ? "已访问" : "未访问" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="payStatus"
            width="100"
            label="是否复购"
          >
            <template slot-scope="scope">
              <div :class="scope.row.payStatus === 'yes' ? 'success' : 'gray'">
                {{ scope.row.payStatus === "yes" ? "已复购" : "未复购" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
import moment from "moment";
import { ToFixed } from "@/utils/utils";
export default {
  data() {
    return {
      moment,
      createTimeArry: [],
      ToFixed,
      list: [],
      h: [
        {
          name: "覆盖人数",
          datalist: [
            {
              title: "覆盖复购总人数",
              val: 0
            }
          ]
        },
        {
          name: "通知人数",
          datalist: [
            {
              title: "导购跟进",
              val: 0
            }
          ]
        },
        {
          name: "访问人数",
          datalist: [
            {
              title: "访问人数",
              val: 0
            }
          ]
        },
        {
          name: "客户加购物车",
          datalist: [
            {
              title: "客户加购物车",
              val: 0
            }
          ]
        },
        {
          name: "付款人数",
          datalist: [
            {
              title: "付款人数",
              val: 0
            },
            {
              title: "付款金额",
              val: 0
            }
            // {
            //   title: "系统通知付款金额",
            //   val: 0
            // },
            // {
            //   title: "导购通知付款金额",
            //   val: 0
            // }
          ]
        }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      row: {},
      purchase1: 0,
      purchase2: 0,
      purchase3: 0,
      purchase4: 0,
      purchase5: 0
    };
  },
  created() {},
  mounted() {
    this.row = JSON.parse(this.$route.query.params);
    if (this.row.queryStartTime) {
      this.createTimeArry = [this.row.queryStartTime, this.row.queryEndTime];
    }
    this.queryRepurchaseEmployeeFollowMemberData();
    this.queryList();
  },
  methods: {
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    createTimeArryChange() {
      this.queryRepurchaseEmployeeFollowMemberData();
      this.queryList();
    },
    async queryRepurchaseEmployeeFollowMemberData() {
      const { result } = await this.$store.dispatch(
        "queryRepurchaseEmployeeFollowMemberData",
        {
          employeeId: this.row.employeeId,
          queryStartTime: this.isArray(this.createTimeArry)
            ? this.createTimeArry[0]
            : "",
          queryEndTime: this.isArray(this.createTimeArry)
            ? this.createTimeArry[1]
            : ""
        }
      );
      this.h.forEach((item, index) => {
        if (index === 0) {
          item.datalist.forEach(v => {
            v.val = result.employeeCoverNum;
          });
        } else if (index === 1) {
          item.datalist[0].val = result.employeeNoticeNum;
        } else if (index === 2) {
          item.datalist[0].val = result.employeeVisitNum;
        } else if (index === 3) {
          item.datalist[0].val = result.employeeAddCartNum;
        } else if (index === 4) {
          item.datalist[0].val = result.employeePayNum;
          item.datalist[1].val = result.employeePayPrice;
        }
      });

      this.purchase1 = result.totalCoverNum
        ? (result.employeeNoticeNum / result.totalCoverNum) * 100
        : 0;
      this.purchase2 = result.employeeNoticeNum
        ? (result.employeeVisitNum / result.employeeNoticeNum) * 100
        : 0;
      this.purchase3 = result.employeeVisitNum
        ? (result.employeeAddCartNum / result.employeeVisitNum) * 100
        : 0;
      this.purchase4 = result.employeeAddCartNum
        ? (result.employeePayNum / result.employeeAddCartNum) * 100
        : 0;
      this.purchase5 = result.totalCoverNum
        ? (result.employeePayNum / result.totalCoverNum) * 100
        : 0;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        employeeId: this.row.employeeId,
        queryStartTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[0]
          : "",
        queryEndTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[1]
          : ""
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryRepurchaseEmployeeMemberList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss">
.remind-plan {
  .xxxx {
    padding: 0px;
    .cell {
      padding: 0px;
      margin-left: -10px;
    }
    .bg {
      background: #f7f7f7;
    }
  }
}
</style>
<style scoped lang="scss">
.border-b1 {
  border-bottom: 1px solid #ebeef5;
}

.product-analysis {
  margin-bottom: 10px;
  padding: 10px;
  .title {
    color: #222222;
    font-weight: bold;
    margin-bottom: 18px;
    font-size: 16px;
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.funnel {
  background-image: url("https://imgcdn.hemiao100.com/ThemePictures/effectanalysisimg.png");
  height: 470px;
  background-size: 98% 100%;
  position: relative;
  background-repeat: no-repeat;

  .funnel-row {
    .data-info {
      font-size: 15px;
      line-height: 26px;
      margin: 20px 0;
      width: 140px;
      // text-align: center;
      padding-left: 30px;
      box-sizing: border-box;
      &.bor-right {
        border-right: 1px solid #ffb6d5;
      }
    }
    .tit {
      font-size: 18px;
      color: #fff;
      margin-right: 26%;
      white-space: nowrap;
      &.carts {
        margin-right: 24.5%;
      }
    }
  }

  .cover-purchase1 {
    position: absolute;
    top: 14%;
    right: 5.5%;
    font-size: 14px;
  }
  .cover-purchase2 {
    position: absolute;
    top: 36%;
    right: 7.9%;
    font-size: 14px;
  }
  .cover-purchase3 {
    position: absolute;
    bottom: 34%;
    right: 10.4%;
    font-size: 14px;
  }
  .cover-purchase4 {
    position: absolute;
    bottom: 12%;
    right: 12.5%;
    font-size: 14px;
  }
  .cover-purchase5 {
    position: absolute;
    transform: translate(-50%, -50%);
    right: 1%;
    top: 55%;
    font-size: 14px;
  }
}
</style>
